/**
 * Based in a list of image urls, return the greater size specified in the image url.
 * @param images {string[]}
 * @return string
 */
export default function filterImageBySize(images) {
  return (
    images?.reduce((current, url) => {
      const pictureSize = parseInt(
        url.split('/')?.pop()?.split('x')?.[0] || '0'
      )
      const currentSize = parseInt(
        current?.split('/')?.pop()?.split('x')?.[0] || '0'
      )

      if (pictureSize > currentSize) {
        return url
      }
      return current
    }, null) || images?.[0]
  )
}
